/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { Stack, Image, Container, Row, Col } from 'react-bootstrap';

import '../../styles/Footer.css';

import logo_riouglass from '../../images/logo-riou-glass.webp';
import logo_pellini from '../../images/logo-pellini.webp';

function Footer() {
	return (
		<Container style={{ paddingBottom: '8%', paddingTop: '10%' }}>
			<Row>
				<Col style={{ margin: 'auto' }}>
					<Image src={logo_riouglass} style={{ filter: 'invert(100%)', width: '65%' }}/>
				</Col>
				<Col style={{ margin: 'auto' }}>
					<Image src={logo_pellini} style={{ width: '65%' }}/>
				</Col>
				<Col>
					<Stack>
						<p>+33 (0)2 31 14 40 10</p>
						<a href='mailto:contact@storevision.fr'>contact@storevision.fr</a>
						<a href='https://www.storevision.fr/mentions-legales/'>Mentions légales</a>
					</Stack>
				</Col>
			</Row>
		</Container>
	);
}

export default Footer;
